import { render, staticRenderFns } from "./PolicyRegulation.vue?vue&type=template&id=4c1a6dce&scoped=true&"
import script from "./PolicyRegulation.vue?vue&type=script&lang=js&"
export * from "./PolicyRegulation.vue?vue&type=script&lang=js&"
import style0 from "./PolicyRegulation.vue?vue&type=style&index=0&id=4c1a6dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a6dce",
  null
  
)

export default component.exports